import { render, staticRenderFns } from "./BaseArrowRightIcon.vue?vue&type=template&id=136b8364"
import script from "./BaseArrowRightIcon.vue?vue&type=script&lang=js"
export * from "./BaseArrowRightIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports